import React from 'react'
import './../../App.css'; // Import the CSS file for styling

export const Nav = () => {
  return (
    <nav
        style={{
            position: 'relative', // Enables positioning of child elements
            textAlign: 'center',
            backgroundColor: 'transparent', // Preserve transparency
        }}
    >
        <ul className='header-list'>
          
          <li className='header-area'><a href="/" className="nav-link">Home</a></li>
          
          {/* <li className='header-area'>About</li> */}
          {/* • */}
          {/* <li className='header-area'>Contact</li> */}
        </ul>
      </nav>
  )
}


export default Nav;